import AbstractRequestTask from '../../../requests/tasks/AbstractRequestTask';

class ManifestTask extends AbstractRequestTask {
  constructor(url) {
    super();
    this.url = url;
  }

  getUrl() {
    return this.url;
  }

  isValid(data) {
    return true;
  }

  getShowModal() {
    return false;
  }

  getParams() {
    return {};
  }
}

export default ManifestTask;



// WEBPACK FOOTER //
// ./src/utils/webinitiator/requests/ManifestTask.js